/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIvAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17 8a1 1 0 0 1 1 1v1h1v2h-1v2h-1v1a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3v-3.5a1 1 0 1 0-2 0V17a3 3 0 0 0 3 3h11v2H9a5 5 0 0 1-5-5v-5.5a3 3 0 0 1 6 0V15a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1h-1v-2h-1v-2h1V9a1 1 0 0 1 1-1zm0-4.134V7h-2V2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIvAlt as IvAlt };
